/* Zevar Palace - infinite scroll for collection + search pages (Dawn) */
(function () {
  var loading = false;
  var observer = null;

  function getSentinel() {
    return document.getElementById('zp-infinite-scroll');
  }

  /* Collection page: #product-grid is the <ul>. Search page: #product-grid is a wrapper <div> around ul.product-grid */
  function getList(root) {
    if (!root) return null;
    var grid = root.getElementById ? root.getElementById('product-grid') : null;
    if (!grid) return null;
    if (grid.tagName === 'UL') return grid;
    return grid.querySelector('ul.product-grid');
  }

  function showPagination(sentinel) {
    var wrap = sentinel && sentinel.parentElement && sentinel.parentElement.querySelector('.pagination-wrapper');
    if (wrap) wrap.style.display = '';
  }

  function init() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    loading = false;
    var sentinel = getSentinel();
    if (!sentinel) return;

    if (!('IntersectionObserver' in window) || !window.fetch || !window.DOMParser) {
      return; /* old browser: keep normal page numbers */
    }

    var wrap = sentinel.parentElement.querySelector('.pagination-wrapper');
    if (wrap) wrap.style.display = 'none';

    if (!sentinel.getAttribute('data-next-url')) {
      sentinel.remove();
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '0px 0px 900px 0px' });
    observer.observe(sentinel);
  }

  function loadNext() {
    var sentinel = getSentinel();
    var list = getList(document);
    if (!sentinel || !list || loading) return;
    var url = sentinel.getAttribute('data-next-url');
    if (!url) return;

    loading = true;
    sentinel.classList.add('is-loading');

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        /* Filters/sort may have replaced the grid while we were loading */
        if (getSentinel() !== sentinel) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = getList(doc);
        if (newList) {
          var items = newList.children;
          var frag = document.createDocumentFragment();
          for (var i = 0; i < items.length; i++) {
            var li = document.importNode(items[i], true);
            li.classList.remove('scroll-trigger', 'animate--slide-in');
            li.removeAttribute('data-cascade');
            frag.appendChild(li);
          }
          list.appendChild(frag);
        }

        var nextSentinel = doc.getElementById('zp-infinite-scroll');
        var nextUrl = nextSentinel ? nextSentinel.getAttribute('data-next-url') : '';
        if (nextUrl) {
          sentinel.setAttribute('data-next-url', nextUrl);
        } else {
          if (observer) observer.disconnect();
          observer = null;
          sentinel.remove();
        }
      })
      .catch(function () {
        /* on any error fall back to normal page numbers */
        if (observer) observer.disconnect();
        observer = null;
        showPagination(sentinel);
        sentinel.remove();
      })
      .then(function () {
        loading = false;
        if (sentinel.isConnected) {
          sentinel.classList.remove('is-loading');
          if (observer) {
            /* re-check: if the loader is still on screen, load the next batch */
            observer.unobserve(sentinel);
            observer.observe(sentinel);
          }
        }
      });
  }

  function watchFilters() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !('MutationObserver' in window)) return;
    new MutationObserver(function () {
      init();
    }).observe(container, { childList: true });
  }

  function start() {
    init();
    watchFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
